import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from "@azure/msal-react";
import { Container, Tabs } from "@EMOrg-prd/react-standard";
import Header from "./components/Header";
import TokenForm from "./components/TokenForm";
import APIForm from "./components/APIForm";
import { FormProvider } from "./modules/FormContext";

const App = () => (
  <>
    <Header />
    <Container>
      <AuthenticatedTemplate>
        <FormProvider>
          <Tabs variant="underlined" border="none">
            <Tabs.Item title="Token Request">
              <TokenForm />
            </Tabs.Item>
            <Tabs.Item title="API">
              <APIForm />
            </Tabs.Item>
          </Tabs>
        </FormProvider>
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        Please <b>login</b> to access this application
      </UnauthenticatedTemplate>
    </Container>
  </>
);

export default App;
